import wishlistButtons from './partials/buttons'
import shareBox from './partials/share-box'

const wishlist = {
    ...wishlistButtons,
    ...shareBox,
}

export default wishlist
